import { GantPoItemVariant } from "./gant-po-item-variant";

export class GantPoItemDetails {

    style: string;
    colorCode:string;
    GantpoItemVariantDetails: GantPoItemVariant[]

}